import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';
import { trackLinkClick } from './tracking';
import { OffersLink } from '../../components/OffersLink';
import { useOffersListingUrl } from '../../hooks';
import { selectPromoDetails, selectPromoProduct } from '../../selectors/promoDetails';
import { IPromoProduct } from '../../types/product';
import { IPromoOffer } from '../../types/promoDetails';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { CallButton } from '../CallButton';
import { MobileCallButton } from '../CallButton/MobileCallButton';
import { trackCallButtonClick } from '../CallButton/tracking';

export const Controls = (): React.JSX.Element => {
  const promoDetails = useSelector(selectPromoDetails);
  const promoProduct = useSelector(selectPromoProduct);

  const offersListingUrl = useOffersListingUrl(promoDetails?.newbuildingIds || []);

  const handleOfferListingLinkClick = React.useCallback(() => {
    trackLinkClick({ product: promoProduct as IPromoProduct, type: 'to_offers' });
  }, [promoProduct]);

  const onCallClick = React.useCallback(() => {
    const id = promoDetails?.phoneNewbuildingId;
    const gaLabel = promoDetails?.gaLabel;
    const promoId = promoDetails?.uniqueId;

    if (!id || !gaLabel || !promoId) {
      return;
    }

    trackCallButtonClick({
      customUrl: gaLabel,
      id,
      action: 'Open_detail_promo',
      extra: { promoId },
    });
  }, [promoDetails]);

  const callButtonContext = React.useMemo(() => {
    const phone = promoDetails?.builderPhone;
    if (phone && phone.countryCode) {
      phone.countryCode = phone.countryCode.replace(/\D/g, '');
    }

    const builder = {
      phones: promoDetails?.builderPhone ? [promoDetails.builderPhone] : [],
    };

    return {
      builder,
      siteBlockId: promoDetails?.siteBlockId,
      offerId: promoDetails?.phoneNewbuildingId,
    } as IPromoOffer;
  }, [promoDetails]);

  return (
    <>
      <OffersLink url={offersListingUrl} onClick={handleOfferListingLinkClick} />
      <PromoOfferCardContext.Provider value={callButtonContext}>
        <Responsive desktop tablet>
          <CallButton onClick={onCallClick} theme="fill_primary" size="M" placeType="promoPopup" />
        </Responsive>
        <Responsive phone>
          <MobileCallButton placeType="promoPopup" />
        </Responsive>
      </PromoOfferCardContext.Provider>
    </>
  );
};
